module.exports = __webpack_public_path__ + "static/media/crybanners_sm1.c981a0fe.jpg";